import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_ARMS_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-barbell-bicep-curl",
    "name": "站姿杠铃弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "barbell",
    "pattern": "站姿杠铃肘屈",
    "legacyIds": [
      "barbell-bicep-curl"
    ],
    "sourceId": "course-20261008-four-way-02-06",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-kneel-tricep-dip",
    "name": "跪姿肘屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "bodyweight",
    "pattern": "跪姿闭链肘伸",
    "legacyIds": [
      "kneel-tricep-dip"
    ],
    "sourceId": "course-20261008-four-way-02-07",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "同一动作在私教用于热身、四分化用于正式；标准库只保留一个手臂动作，合集各自阶段保留"
  },
  {
    "id": "library-supine-cable-tricep",
    "name": "仰卧绳索臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "cable",
    "pattern": "仰卧双臂肘伸",
    "legacyIds": [
      "supine-cable-tricep"
    ],
    "sourceId": "course-20261008-four-way-04-09",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-seated-cable-curl",
    "name": "坐姿绳索弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "cable",
    "pattern": "坐姿绳索肘屈",
    "legacyIds": [
      "seated-cable-curl"
    ],
    "sourceId": "course-20261008-personal-03-03",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-behind-neck-cable-tricep",
    "name": "站姿颈后绳索臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "cable",
    "pattern": "站姿过顶绳索肘伸",
    "legacyIds": [
      "behind-neck-cable-tricep"
    ],
    "sourceId": "course-20261008-four-way-04-10",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-bent-tricep-kickback",
    "name": "俯身哑铃臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "dumbbell",
    "pattern": "肩伸位哑铃肘伸",
    "legacyIds": [
      "home-bent-tricep-kickback"
    ],
    "sourceId": "course-20261008-home-01-08",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-seated-behind-neck-tricep",
    "name": "坐姿哑铃颈后臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "dumbbell",
    "pattern": "坐姿过顶哑铃肘伸",
    "legacyIds": [
      "home-seated-behind-neck-tricep"
    ],
    "sourceId": "course-20261008-home-01-07",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-dumbbell-curl",
    "name": "哑铃弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "dumbbell",
    "pattern": "站姿哑铃肘屈",
    "legacyIds": [
      "home-dumbbell-curl"
    ],
    "sourceId": "course-20261008-home-02-06",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-lying-extension",
    "name": "仰卧杠铃臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "barbell",
    "pattern": "仰卧杠铃肘伸",
    "legacyIds": [
      "ksw-lying-extension",
      "threeway-barbell-skull-crusher"
    ],
    "sourceId": "course-20261008-personal-03-02",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-cable-curl",
    "name": "站姿绳索直杆弯举",
    "group": "arms",
    "subCategory": "biceps",
    "equipment": "cable",
    "pattern": "站姿直杆绳索肘屈",
    "legacyIds": [
      "ksw-cable-curl"
    ],
    "sourceId": "course-20261008-ksw-collection-02-10",
    "targetMuscles": [
      "肱二头肌",
      "肱肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-bench-dip",
    "name": "凳上反向臂屈伸",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "bodyweight",
    "pattern": "凳上反撑肘伸",
    "legacyIds": [
      "threeway-bench-dip"
    ],
    "sourceId": "threeway-bench-dip",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s2-cable-tricep-pushdown",
    "name": "绳索三头下压",
    "group": "arms",
    "subCategory": "triceps",
    "equipment": "cable",
    "pattern": "站姿绳把肘伸",
    "legacyIds": [
      "personal-s2-cable-tricep-pushdown",
      "personal-s8-cable-tricep-pushdown"
    ],
    "sourceId": "course-20261008-personal-02-08",
    "targetMuscles": [
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
